// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3av5r","col":"styles_col__2Ydm7"};